import SocketConnector from '@sparling/financial-socket-connector'
import { setStepperFormData } from './setStepperFormData'
import { getStepperFormData } from './getStepperFormData'
import { clearStepperFormData } from './clearStepperFormData'
import { introducerRequest, fetchUserReferrals } from './introducer'
import { confirmReceivedAmount, requestSettlement } from './user-wallets'
import {
  createUserBankAccount,
  fetchUserBankAccounts,
  updateUserBankAccount,
  deleteUserBankAccount,
  fetchUserSfBankAccounts,
  fetchUserBankAccountList,
} from './bank-accounts'
import {
  createUserWallet,
  fetchUserWallets,
  updateUserWallet,
  deleteUserWallet,
  fetchUserSfWallets,
  fetchUserWalletsList,
} from './wallets'
import { createOrder } from './orders'
import { getTradableInstruments } from './instruments'
import { getBalances } from './balances'
import { fetchTradingHistory } from './trades'
import { loginUser, login2FAUser, logoutUser } from './login'
import { fetchUser, fetchClientTypesForAssignToUser, userClientTypeChangeRequest } from './user'
import { fetchHistoryData } from './history'
import { cancelTransaction } from './transactions'

export default {
  setStepperFormData,
  getStepperFormData,
  clearStepperFormData,
  introducerRequest,
  fetchUserReferrals,
  confirmReceivedAmount,
  createUserBankAccount,
  fetchUserBankAccounts,
  fetchUserBankAccountList,
  updateUserBankAccount,
  deleteUserBankAccount,
  createUserWallet,
  fetchUserWallets,
  updateUserWallet,
  deleteUserWallet,
  fetchUserSfBankAccounts,
  fetchUserSfWallets,
  fetchUserWalletsList,
  requestSettlement,
  createOrder,
  getTradableInstruments,
  getBalances,
  fetchTradingHistory,
  ws: SocketConnector.getInstance(),
  loginUser,
  login2FAUser,
  logoutUser,
  fetchUser,
  fetchClientTypesForAssignToUser,
  userClientTypeChangeRequest,
  fetchHistoryData,
  cancelTransaction,
}
